export const listenToAccessibilityKeyboardInputs = (button: Element | null) => {
    // Set keyboard event listener for all markup marked as button
    button?.addEventListener('keydown', function (e: Event) {
        const evt = e as KeyboardEvent;
        if (evt.code === 'Enter') {
            e.preventDefault();
            const anchorElement = (button as HTMLAnchorElement) ?? null;
            if (anchorElement) {
                anchorElement!.click();
            } else {
                button?.dispatchEvent(new MouseEvent('click'));
            }
        }
    });
};

export const isChrome = () => {
    return (
        navigator.userAgent.toLowerCase().indexOf('chrome') > -1 &&
        navigator.vendor.toLowerCase().indexOf('google') > -1
    );
};
